import useHotelPackageSelectionExperiment from 'components/OfferPage/packageSelection/useHotelPackageSelectionExperiment'

type Options = Parameters<typeof useHotelPackageSelectionExperiment>[0] & { isIndividualMode: boolean }

export default function useFlashPackageSelectionExperiment({ isIndividualMode, isEligible, ...options }: Options) {
  return useHotelPackageSelectionExperiment({ ...options, isEligible, canExpose: !isIndividualMode })
}
